import { BRAND } from "../theme";

// A list in a map popup (the crime popups' crime types) showing its first few rows,
// with the rest behind a "More (N)" toggle. Popups are HTML strings, so the rows past
// the first few get the class 'extra' and the toggle shows or hides them in the DOM.

export const MORE_SHOWN = 3;

// Whether a list of count rows folds, and whether it starts open: a list of 4 or fewer
// shows every row (hiding one row isn't worth a toggle), and one whose chosen row
// (selectedIndex, -1 for none) would be hidden opens, with no toggle, so it stays seen
export const moreState = (count, selectedIndex=-1) => {
    if (count<=MORE_SHOWN+1) return {folds:false, forced:false};
    if (selectedIndex>=MORE_SHOWN) return {folds:false, forced:true};
    return {folds:true, forced:false};
};

// The class to add to the list's container, starting folded
export const moreListClass = (state) => state.folds ? ' folded' : '';

// The class to add to the row at index i
export const moreRowClass = (i, state) => (state.folds && i>=MORE_SHOWN) ? 'extra' : '';

const CHEVRON = '<svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true"><path d="M2 3.5 5 6.5 8 3.5" '+
    'fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

// The toggle under the list, for count rows; nothing when the list doesn't fold (only
// a mark when it is held open by its chosen row)
export const moreToggleHTML = (count, state) => state.forced ? '<span data-more-forced hidden></span>' : !state.folds ? '' :
    '<span class="moretoggle" data-more-toggle data-more-count="'+(count-MORE_SHOWN)+'" role="button" aria-expanded="false">'+
    '<span>More ('+(count-MORE_SHOWN)+')</span>'+CHEVRON+'</span>';

// Its styles, under the popup's class (e.g. '.areaPopup'); list is the rows' container
export const moreToggleCSS = (scope, list='.keys') =>
    scope+' '+list+'.folded .extra {display:none !important;} '+
    scope+' .moretoggle {display:inline-flex; align-items:center; gap:4px; justify-self:start; align-self:start; width:max-content; '+
        'font-size:.75em; font-weight:600; color:'+BRAND.ink+'; cursor:pointer; text-decoration:underline; '+
        'text-decoration-color:#b9c4bf; text-underline-offset:2px; margin-top:-2px;} '+
    scope+' .moretoggle:hover {text-decoration-color:'+BRAND.ink+';} '+
    scope+' .moretoggle svg {transition:transform .15s;} '+
    scope+' .moretoggle[aria-expanded="true"] svg {transform:rotate(180deg);} ';

// Whether the user opened the list, kept while the popup redraws for the same area
// (e.g. after picking a crime type) and forgotten when it shows another
let openFor = null;

// Wires the toggle in a popup's content; area is the feature it shows
export const attachMoreToggle = (content, area) => {
    const toggle = content.querySelector('[data-more-toggle]');
    if (!toggle) {
        // A list held open by its chosen row stays open for this area when the
        // user then picks one of the first few
        if (content.querySelector('[data-more-forced]')) openFor = area;
        else if (area!==openFor) openFor = null;
        return;
    }
    const list = toggle.previousElementSibling;
    if (!list) return;
    const count = toggle.getAttribute('data-more-count');
    const set = (open) => {
        list.classList.toggle('folded', !open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.firstChild.textContent = open ? 'Less' : 'More ('+count+')';
    };
    set(area!=null && area===openFor);
    toggle.onclick = (evt) => {
        evt.stopPropagation();
        const open = !list.classList.contains('folded');
        openFor = open ? null : area;
        set(!open);
    };
};
